module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2mb0B"))).then(() => parcelRequire('hEqeo'));